import ContentWrapper from "@/components/layouts/DashboardLayout/Content";
import TableHeaderFixed from "@/components/TableCustom/tableHeaderFixed";
import FilterComponent from "./components/FilterComponent";
import Title from "antd/es/typography/Title";
import routes from "@/routes";
import PersonIcon from "@/assets/icons/PersonIcon";
import { useEffect, useRef, useState } from "react";
import { columns } from "./userRoleManagerment.constants";
import { Row, Spin } from "antd";
import { checkTotalAllItem } from "@/utils/helpers";
import { useGetRoleListQuery } from "@/rtk-query/commonQueries";
import C from "@/utils/constants";

function UserRoleManagementModule() {
  const [data, setData] = useState<Array<any>>([]);
  const page = 1;

  const { currentData } = useGetRoleListQuery({
    page,
    pageSize: C.PAGE_SIZE,
  });
  
  useEffect(() => {
      const initData = page === 1 ? currentData || [] : [...data, ...(currentData || [])];
      setData(initData);
    
  }, [currentData, page]);

  const ref = useRef<HTMLDivElement | null>(null);
  return (
    <ContentWrapper
      headerContent={
        <Title
          level={5}
          style={{
            marginBottom: 20,
            color: "#234C66",
            textTransform: "uppercase",
          }}
        >
          LIST OF ROLES
        </Title>
      }
      renderFilter={<FilterComponent />}
      dataBreadCrumb={[
        {
          title: routes.userRoleList.title,
          icon: <PersonIcon />,
          url: routes.userRoleList.path,
        },
      ]}
    >
      <TableHeaderFixed
        data={data}
        columns={columns({
          onDelete: () => true,
          onRestore: () => true,
          isLoadingExportUserApi: false,
          isLoadingExportWarehouseApi: false,
          loadingList: [],
        })}
        total={checkTotalAllItem(1)}
        loading={false}
      />
      {currentData && Number(currentData?.page) < Number(currentData?.totalPage) && (
        <Row
          ref={ref}
          justify="center"
          style={{
            padding: 36,
          }}
        >
          <Spin tip="Loading" size="large" />
        </Row>
      )}
    </ContentWrapper>
  );
}

export default UserRoleManagementModule;
